import * as THREE from "three";
window.THREE = THREE;
require("three/examples/js/controls/OrbitControls");
require("three/examples/js/QuickHull");
require("three/examples/js/geometries/ConvexGeometry");

export default THREE;
